<template>
  <b-container fluid class="header" v-if="help">
    <b-jumbotron fluid>
      <h2 class='text-white'>Entries</h2>
      <p class='text-white'>Simplify managing your website</p>
      <b-button @click='help = !help'>Get started</b-button>
    </b-jumbotron>

    <b-container class="mt-4">
      <b-card title="Pages" class="mb-4">
        One off pages which don't match a template.
      </b-card>
      <b-card title="Blogs" class="mb-4">
        Your blog articles
      </b-card>
      <b-card title="Services" class="mb-4">
        Services have both a page for the service as well as a mini block to show on the homepage. Each services follows an identical template.
      </b-card>
      <b-card title="Awards" class="mb-4">
        Your company awards or press logos.
      </b-card>
      <b-card title="Testimonials" class="mb-4">
        Your company testimonials.
      </b-card>
      <b-card title="Forms" class="mb-4">
        Your company forms.
      </b-card>
    </b-container>
  </b-container>

  <b-container fluid v-else>
    <div class="horizontal-menu">
      <b-row>
        <b-col>
          <h2>Entries</h2>
        </b-col>
        <b-col class="float-right">
          <b-button class="float-right" variant="transparent" @click="help = !help"><i class="far fa-question-circle"></i></b-button>
          <LoadingButton class="float-right" :loading="loading_publish" @click="publish_site">Publish</LoadingButton>
        </b-col>
      </b-row>
      <!--  -->
      <b-nav>
        <b-nav-item :to="{name: $route.meta.entry_type}" exact exact-active-class="tab_active">{{$route.meta.entry_type | capitalise}}</b-nav-item>
        <b-nav-item v-if="$route.meta.entry_type === 'forms'" :to="{name: 'form_results'}" exact exact-active-class="tab_active">Results</b-nav-item>
      </b-nav>
    </div>

    <router-view :profile="profile" :user="user" :site="site" />
  </b-container>
</template>

<script>
import api from '@/lib/api.js'
import { db } from '@/main.js'

export default {
  name: 'site_links',
  props: ['profile', 'user', 'site'],
  data() {
    return {
      loading_publish: false,
      help: this.site.help.entries
    }
  },
  filters: {
    capitalise: function(v) {
      return v.charAt(0).toUpperCase() + v.slice(1)
    },
  },
  methods: { // TODO make this button work
    async publish_site() {
      this.loading_publish = true
      await api.publish_site(this.$route.params.site_id)
      this.loading_publish = false
    }
  },
  watch: {
    help(val) {
      if (this.site.help.entries && !val) {
        db.collection('site').doc(this.site.id).update({'help.entries': false})
      }
    }
  }
}
</script>

<style>

</style>
